@if (streamUrl()) {
  <div
    class="flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm cursor-pointer hover:bg-slate-50 transition"
    (click)="downloadFile()"
  >
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-slate-100">
      <i class="bi text-xl" [class]="iconClass()"></i>
    </div>
    <div class="flex min-w-0 flex-col">
      <span class="text-sm font-medium text-slate-800 truncate">{{ displayName() }}</span>
      <span class="text-xs text-slate-500">Click para descargar</span>
    </div>
    <i class="bi bi-download text-slate-400 shrink-0 ml-auto"></i>
  </div>
} @else {
  <div class="flex items-center gap-2 rounded-lg bg-slate-100 px-4 py-3 border border-slate-200">
    <i class="bi bi-file-earmark-x text-slate-400 text-lg"></i>
    <span class="text-sm text-slate-500">Documento no disponible</span>
  </div>
}
